import { siteConfig } from './siteConfig';

const baseTheme = {
  colors: {
    ink: '#0b1524',
    paper: '#f3f1ea',
    white: '#ffffff',
    accent: '#1f6bff',
    sky: '#9cc0ff',
    teal: '#00d1b2',
    error: '#ff8080',
    line: 'rgba(11, 21, 36, 0.12)',
    muted: 'rgba(11, 21, 36, 0.58)',
    onInk: {
      text: 'rgba(243, 241, 234, 0.68)',
      muted: 'rgba(243, 241, 234, 0.58)',
      line: 'rgba(243, 241, 234, 0.18)',
      border: 'rgba(243, 241, 234, 0.28)',
      field: 'rgba(243, 241, 234, 0.06)'
    }
  },
  fonts: {
    sans: "'Space Grotesk', system-ui, -apple-system, sans-serif",
    mono: "'Space Mono', ui-monospace, monospace",
    serif: "'Instrument Serif', Georgia, serif"
  },
  breakpoints: {
    mobile: '576px',
    tablet: '768px',
    desktop: '992px',
    wide: '1200px'
  },
  container: {
    maxWidth: '1320px',
    gutter: 'clamp(20px, 5vw, 64px)'
  },
  spacing: {
    section: 'clamp(80px, 12vh, 150px)'
  },
  navHeight: '64px'
};

export type Theme = typeof baseTheme;

export const theme: Theme = {
  ...baseTheme,
  colors: { ...baseTheme.colors, accent: siteConfig.accent }
};
